import {Component, Injector, OnInit} from '@angular/core';
import {ProductBarcode} from "../../../../models/shop/productBarcode";
import Swal from "sweetalert2";
import {BaseComponent} from "../../../base/base.component";
import {ShopService} from "../../../../services/shop/shop.service";
import {ActivatedRoute} from "@angular/router";
import {ProductSize} from "../../../../models/shop/ProductSize";
import {ProductColor} from "../../../../models/shop/productColor";


@Component({
    selector: 'app-edit-barcode',
    templateUrl: './edit-barcode.component.html',
    styleUrls: ['./edit-barcode.component.scss']
})
export class EditBarcodeComponent extends BaseComponent implements OnInit {

    barcodeId?: string | null;
    barcode: ProductBarcode = new ProductBarcode();
    editPage?: string | null;
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    productDropdownSettings: any = {};
    productId?: string | null;

    sizesList: ProductSize[] = [];
    selectedSizes: ProductSize[] = [];
    colorsList: ProductColor[] = [];
    selectedColors: ProductColor[] = [];

    constructor(public shopService: ShopService,
                public serviceInjector: Injector,
                private router: ActivatedRoute) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.router.queryParamMap.subscribe(queryParams => {
            this.barcodeId = queryParams.get('barcodeId');
            this.editPage = queryParams.get('pageType');
            this.productId = queryParams.get('productId');
        });
        this.productDropdownSettings = {
            idField: 'id',
            textField: "name",
            allowSearchFilter: true,
            singleSelection: true
        };

        if (this.barcodeId) {
            await this.loadData();
        }
        this.sizesList = (await this.shopService.getSizes(this.companyId)).data;
        this.colorsList = (await this.shopService.getColors(this.companyId)).data;
    }


    async loadData() {
        if (this.barcodeId) {
            this.shopService.getBarcodeById(this.barcodeId).subscribe(
                (response: any) => {
                    if (response.success) {
                        this.barcode = response.data;
                        if (this.barcode.size) this.selectedSizes.push(this.barcode.size);
                        if (this.barcode.color) this.selectedColors.push(this.barcode.color);
                    }
                });
        }
    }



    async addBarcode() {
        this.spinner.show();
        this.barcode.companyId = this.companyId;
        this.barcode.sizeId = this.selectedSizes[0].id;
        this.barcode.colorId = this.selectedColors[0].id
        this.barcode.productId = this.productId;

        await this.shopService.addBarcode(this.barcode).then(
            (response: any) => {
                if (response.success) {
                    this.previousPage();
                }
            }
        ).catch((error: any) => {
                console.log(error);
            }
        )
        this.selectedSizes = [];
        this.selectedColors = [];
        this.spinner.hide();
    }

    async editBarcode() {
        this.spinner.show();
        this.barcode.companyId = this.companyId;
        this.barcode.sizeId = this.selectedSizes[0].id;
        this.barcode.colorId = this.selectedColors[0].id
        this.barcode.productId = this.productId;

        await this.shopService.editBarcode(this.barcode).then(
            (response: any) => {
                if (response.success) {
                    this.previousPage()
                }
            }
        ).catch((error: any) => {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: "Errore nella modifica",
            });
        }
        )
        this.selectedSizes = [];
        this.selectedColors = [];
        this.spinner.hide();
    }
}
